import LOGO_PATH from '~/assets/video-player/logo.svg'
import { TIME_CODE_MODE } from '~/config/constants/timecode'

export default {
  LOGO_PATH,
  EDITOR: {
    UNDO_REDO: true,
  },

  LAYER: {
    MUTE: true,
    HIDE: true,
    REARRANGE: true,
  },

  TIME_CODE_MODE: {
    SOURCE_MEDIA_TIME_CODE: TIME_CODE_MODE.MILLISECOND,
    TIMELINE_TIME_CODE: TIME_CODE_MODE.MILLISECOND,
  },

  PREVIEW: {
    KEY_FRAME_STEPPER: false,
    AUTO_PLAY_SELECTED_MEDIA: true,
  },

  SHOW_INOUT_POINTS_TIMELINE: true,
  SHOW_INOUT_POINTS_SOURCE: true,

  TIMELINE: {
    UNDO_REDO: true,
    RECORD_AUDIO: true,
    ADD_MARKER: false,
    COPY_PASTE: true,
    TIME_INPUT: true,
    ZOOM_MENU: false,
    CUT: true,
    DELETE: true,
    SETTINGS: true,
    TOOLBAR: true,
    TIME_CODE_MODE: 'millisecond',
  },

  SOURCE_FILES_MANAGEMENT: {
    SEARCH: true,
    FILTER: true,
    VIEW_OPTIONS: true,
    VIEW_MODE_SETTINGS: false,
    LOAD_MEDIA_ONSCROLL: false,
    LOADING_NUMBER: 12,
    SUPPORTED_FILES: [ '.mp4', '.mov', '.mp3' ],
    RETRY_UPLOAD: false,
    IMPORT_DROPDOWN: true,
    IMPORT_FOLDER: false,
    IMPORT_DROPBOX: false,
    IMPORT_AMAZON: false,
    IMPORT_GDRIVE: false,
    IMPORT_URL: false,
    MOVE_TO_FOLDERS: false,
    MOBILE_IMPORT: false,
  },

  SOURCE_FILES_TYPES: {
    MEDIA: true,
    PROJECT_MEDIA: false,
    FILTERS: false,
    DESIGN: false,
    AUDIO: true,
    IMAGES: true,
    VIDEOS: true,
  },

  SOURCE_FILES_SORTS: {
    NAME: true,
    DATE: true,
    SIZE: false,
    DURATION: false,
  },

  SOURCE_FILES_FILTERS: {
    ALL: true,
    VIDEO: true,
    IMAGES: true,
    AUDIO: true,
    FOLDERS: true,
    MEDIA_RECORDING: {
      VOICEOVER: true,
      WEBCAM: false,
      LIVESTREAM: false,
    },
  },

  MEDIA_ITEM: {
    CODECS_INFO: false,
  },

  MANAGE_PROJECTS: false,
  IMPORT_MEDIA: false,

  SAVE_PROJECT_MENU: {
    DETAILED_PROJECT_STATS_ON_SAVE: false,
    CHOOSE_OUTPUT_FILE_FORMAT: false,
    SAVE_PROJECT_BUTTON: true,
    FILENAME_TITLE: true,
    MAX_FILENAME_LENGTH: 250, // file name only without ext
  },

  SAVE_SETTINGS: {
    CLOSE_CONFIRMATION_ENABLED: true,
    CREATE_OUTPUT_MEDIA: false,
    CLOSE_ON_CANCEL: false,
    DELETE_OUTPUT_ON_CLOSE: false,
    CONFIRMATION_TITLE: 'Close Project?',
    CLEAR_TIMELINE_ON_CLOSE: false,
    REDIRECT_TO_PROJECTS_ON_CLOSE: true,
  },

  MEDIA_SETTINGS: {
    VOLUME: true,
    IMAGE_SHADOW: false,
  },

  AUDIO_SETTINGS: {
    VOLUME: true,
    TRANSITIONS: false,
  },

  GENERATE_AUTH_TOKEN: false,

  CUSTOM: {
    BACKURL: 'https://dev.myvrspot.com/site/login',
    AUTH_TOKEN_MISSED_MESSAGE: 'Please login to your MyVRSpot account to launch the Editor',
  },

  ALLOW_INCOMPATIBLE_FILES: false,

  AUDIO_CATEGORIES: [ 'music', 'sound' ],
  IMAGES_AI_SOURCE: false,

  PROJECT_IMPORT: false,

  IS_CHROMAKEY_ENABLED: true,
}
